//Import Libraries
import { useState, useEffect } from 'react';

//Import Custom Hooks & Components
import { projectStorage, projectFirestore, timestamp } from '../firebase/config';
import { resizeImage } from '../utils/utils'


const useStorage = (file, fileMetaData, deleteFlag) => {
  
  //Original Image
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState(null);
  const [url, setUrl] = useState(null);

  //Compressed Image
  const [progressCompressed, setProgressCompressed] = useState(0);
  const [errorCompressed, setErrorCompressed] = useState(null);
  const [urlCompressed, setUrlCompressed] = useState(null);

  useEffect(() => {
    // references
    const storageRef = projectStorage.ref(`${fileMetaData.path}/${fileMetaData.pictureId}`);
    const storageRefCompressed = projectStorage.ref(`${fileMetaData.pathCompressed}/${fileMetaData.pictureId}.jpeg`)
    const collectionRef = projectFirestore.collection(fileMetaData.path);
    
    if (deleteFlag) {
      // Delete the file
      storageRef.delete().then(() => {
        // Original file deleted 
        // Now delete the resized file 
        storageRefCompressed.delete().then(() => {
        // Resized file deleted
        // Now delete the metadata from database 
        collectionRef.doc(fileMetaData.id).delete().then(function() {
          setProgress(100);
          setProgressCompressed(100);
          setUrl('Document successfully deleted!');
          setUrlCompressed('Document successfully deleted!');
        }).catch(err => {
          setError(err);
        });
        }).catch(err => {
          setErrorCompressed(err);
        });
      }).catch(err => {
        setError(err)
      });
    } else if (file) { 
      
      //upload the file to storage if it's a new file upload  
      storageRef.put(file).on('state_changed', (snap) => {
        let percentage = (snap.bytesTransferred / snap.totalBytes) * 100;
        setProgress(percentage);
      }, (err) => {
        setError(err);
      }, async () => {
        const url = await storageRef.getDownloadURL();
        const createdAt = timestamp();
        setUrl(url);

        //Resize Image
        const resizedImage = resizeImage(fileMetaData)
        //Once the image is resized, upload it to storage
        resizedImage.then(img => {
          img.getBufferAsync('image/jpeg').then(imgBuffer => {
            let options = {type: 'image/jpeg'};
            var resizedImageBlob = new Blob([imgBuffer], options);
            storageRefCompressed.put(resizedImageBlob).on('state_changed', (snap) => {
              let percentage = (snap.bytesTransferred / snap.totalBytes) * 100;
              setProgressCompressed(percentage);
            }, (err) => {
              setErrorCompressed(err);
            }, async () => {
              const urlCompressed = await storageRefCompressed.getDownloadURL();
              await collectionRef.add({
                ...fileMetaData, 
                url,
                urlCompressed,
                createdAt, 
              });
              setUrlCompressed(urlCompressed);
            });
          });
        })
      });
    } else { 
      //else just update the database with the updated metadata
      collectionRef.doc(fileMetaData.id).update(fileMetaData)
      .then(() => {
        setUrl(fileMetaData.url);
        setUrlCompressed(fileMetaData.urlCompressed);
        setProgress(100);
        setProgressCompressed(100);
      })
      .catch(err => {
        setError(err);
      });
    }
    
  }, [file]);

  return { progress, url, error, progressCompressed, urlCompressed, errorCompressed };
}

export default useStorage;